import { actions } from './action'

const initialState = {
  requestType: [],
  exceptionList: [],
  attendance: [],
  exceptionRecord: [],
  // Pending is the default AR view.
  status: 0,
  totalCount: 0,
  latestListRequestId: 0,
  pagination: {
    skip: 0,
    limit: 10,
  },
}

const exception = (state = initialState, action) => {
  switch (action.type) {
    case actions.GET_REQUEST_TYPE:
      return {
        ...state,
        requestType: action.payload,
      }
    case actions.GET_EXCEPTION:
      if (
        action.payload?.requestId &&
        Number(action.payload.requestId) < Number(state.latestListRequestId || 0)
      ) {
        return state
      }

      return {
        ...state,
        exceptionList: action.payload.exceptionList,
        totalCount: action.payload.totalCount,
        latestListRequestId: action.payload.requestId || state.latestListRequestId,
      }
    case actions.HANDLE_ATTENDANCE:
      return {
        ...state,
        attendance: action.payload,
      }
    case actions.HANDLE_PAGINATION:
      return {
        ...state,
        pagination: action.payload,
      }
    case actions.HANDLE_STATUS:
      return {
        ...state,
        status: action.status,
      }
    case actions.GET_SINGLE_EXCEPTION_RECORD:
      return {
        ...state,
        exceptionRecord: action.payload,
      }
    case actions.UPDATE_EXCEPTION_STATUS_IN_LIST: {
      const activeStatus = state.status
      const showAllStatuses = activeStatus === undefined || activeStatus === null

      return {
        ...state,
        exceptionList: state.exceptionList
          .map((item) => {
            const exceptionRecord = item?.Exception || item

            if (Number(exceptionRecord?.id) !== Number(action.payload.id)) {
              return item
            }

            if (item?.Exception) {
              return {
                ...item,
                ...(action.payload.displayStatus === undefined
                  ? {}
                  : { displayStatus: action.payload.displayStatus }),
                ...(action.payload.displayStatusLabel === undefined
                  ? {}
                  : { displayStatusLabel: action.payload.displayStatusLabel }),
                Exception: {
                  ...item.Exception,
                  exceptionStatus: action.payload.exceptionStatus,
                },
              }
            }

            return {
              ...item,
              exceptionStatus: action.payload.exceptionStatus,
              ...(action.payload.displayStatus === undefined
                ? {}
                : { displayStatus: action.payload.displayStatus }),
              ...(action.payload.displayStatusLabel === undefined
                ? {}
                : { displayStatusLabel: action.payload.displayStatusLabel }),
            }
          })
          .filter((item) => {
            const exceptionRecord = item?.Exception || item

            return (
              showAllStatuses || Number(exceptionRecord?.exceptionStatus) === Number(activeStatus)
            )
          }),
        totalCount:
          showAllStatuses || Number(action.payload.exceptionStatus) === Number(activeStatus)
            ? state.totalCount
            : Math.max(0, Number(state.totalCount || 0) - 1),
      }
    }
    default:
      return state
  }
}

export default exception
